module.exports = __webpack_public_path__ + "img/card_choose_1.96e00149.png";